export default __webpack_public_path__ + "static/media/doctor1.8ec84a43.jpg";